import React from 'react';
import { withStyles, WithStyles, Theme, createStyles } from '@material-ui/core';
import { withIntl, IntlProps } from 'ha/i18n';
import { Grid, units } from '@ha/dsl';
import {
  Label,
  StyledTab,
  StyledTabs,
  TabPanel,
} from 'ha/components/StyledTabs';

import { HowItWorks } from 'ha/components/HowItWorks';
import { tenantVps, landlordVps } from 'ha/components/HowItWorks/constants';
import { Testimonial } from './Testimonial';

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginTop: units.rem(2.5),

      [theme.breakpoints.up('md')]: {
        marginTop: units.rem(5),
      },
    },
    tabs: {
      padding: units.yx(0, 0.5),
      marginBottom: units.rem(4),
    },
    activeTab: {
      color: theme.palette.primary.main,
    },
    howItWorksSection: {
      marginBottom: units.rem(3.75),

      [theme.breakpoints.up('md')]: {
        marginBottom: units.rem(6.25),
      },
    },
  });

export class InfoSectionInternal extends React.Component<
  IntlProps & WithStyles<typeof styles>
> {
  state = {
    currentTabIndex: 0,
  };

  handleTabChange = (
    _: React.ChangeEvent<HTMLSelectElement>,
    newTabIndex: number,
  ) => {
    // We want to trigger scroll to initialize lazy loading for images
    if (window) {
      window.scrollTo(window.scrollX, window.scrollY - 1);
      window.scrollTo(window.scrollX, window.scrollY + 1);
    }

    this.setState({ currentTabIndex: newTabIndex });
  };

  render() {
    const { currentTabIndex } = this.state;
    const {
      intl: { T, urlResolver },
      classes,
    } = this.props;

    const ctaButtonText = T('Learn more');

    return (
      <div className={classes.root}>
        <Grid container justify="center" className={classes.tabs}>
          <StyledTabs value={currentTabIndex} onChange={this.handleTabChange}>
            <StyledTab
              label={<Label>{T('home_page_info_section_for_tenants')}</Label>}
              selectedClassName={classes.activeTab}
              data-test-locator="Home InfoSection StyledTab ForTenants"
            />
            <StyledTab
              label={<Label>{T('home_page_info_section_for_landlords')}</Label>}
              selectedClassName={classes.activeTab}
              data-test-locator="Home InfoSection StyledTab ForLandlords"
            />
          </StyledTabs>
        </Grid>
        <TabPanel
          currentTabIndex={currentTabIndex}
          index={0}
          data-test-locator="Home InfoSection TabPanel ForTenants"
        >
          <div className={classes.howItWorksSection}>
            <HowItWorks
              vps={tenantVps}
              ctaUrl={urlResolver.getRenting()}
              ctaButtonText={ctaButtonText}
              data-test-locator="Home InfoSection HowItWorks ForTenants"
            />
          </div>
          <Testimonial
            data-test-locator="Home InfoSection Testimonial ForTenants"
            isTenant
          />
        </TabPanel>
        <TabPanel
          currentTabIndex={currentTabIndex}
          index={1}
          data-test-locator="Home InfoSection TabPanel ForLandlords"
        >
          <div className={classes.howItWorksSection}>
            <HowItWorks
              vps={landlordVps}
              ctaUrl={urlResolver.getRentingOut()}
              ctaButtonText={ctaButtonText}
              data-test-locator="Home InfoSection HowItWorks ForLandlords"
            />
          </div>
          <Testimonial
            ctaUrl={urlResolver.getBecomeAnAdvertiserUrl()}
            data-test-locator="Home InfoSection Testimonial ForLandlords"
          />
        </TabPanel>
      </div>
    );
  }
}

const InfoSection = withStyles(styles)(withIntl(InfoSectionInternal));
export { InfoSection };
